import { render, staticRenderFns } from "./RefinementTasks.vue?vue&type=template&id=3b30c1e3&scoped=true"
import script from "./RefinementTasks.vue?vue&type=script&lang=js"
export * from "./RefinementTasks.vue?vue&type=script&lang=js"
import style0 from "./RefinementTasks.vue?vue&type=style&index=0&id=3b30c1e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b30c1e3",
  null
  
)

export default component.exports